import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateConfirmationModalComponent } from './template-confirmation-modal.component';
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [TemplateConfirmationModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [TemplateConfirmationModalComponent]
})
export class TemplateConfirmationModalModule { }



